const { FieldsetManager } = require('../managers/FieldsetManager');

// Подключаем глобальные файлы (при необходимости)
require('./globals');
require('./prototypes');

// Тестовое изменение для проверки скорости сборки
// Функция для автоматического подключения и инициализации всех обсерверов
const initializeObservers = () => {
  // Используем require.context для импорта всех .js-файлов из папки ./observers
  const requireModule = require.context('../observers', false, /\.js$/);

  // Получаем список всех файлов-модулей
  requireModule.keys().forEach((moduleFile) => {
    const moduleExports = requireModule(moduleFile);

    // Перебираем все экспорты из модуля
    Object.entries(moduleExports).forEach(([exportName, exportValue]) => {
      // Проверяем, является ли экспорт классом (функцией-конструктором)
      if (typeof exportValue === 'function') {
        try {
          // Создаём экземпляр класса
          new exportValue();
          // console.log(`Инициализирован обсервер: ${exportName}`);
        } catch (error) {
          console.error(`Ошибка инициализации наблюдателя '${exportName}':`, error);
        }
      }
    });
  });
};

// Инициализируем все наблюдатели при загрузке DOM
document.addEventListener('DOMContentLoaded', () => {
  initializeObservers();
  window.fieldsetManager = new FieldsetManager();
});
